import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Horizontal swipe/scroll row with snap + desktop arrow buttons.
export default function HScroll({ children, testid, className = 'gap-3 md:gap-4' }) {
  const ref = useRef(null);
  const [edges, setEdges] = useState({ start: true, end: false });

  const update = () => {
    const el = ref.current;
    if (!el) return;
    setEdges({ start: el.scrollLeft <= 4, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 4 });
  };

  useEffect(() => {
    update();
    const el = ref.current;
    const ro = new ResizeObserver(update);
    if (el) ro.observe(el);
    return () => ro.disconnect();
  }, [children]);

  const go = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.85, behavior: 'smooth' });

  const Arrow = ({ dir }) => {
    const hidden = dir < 0 ? edges.start : edges.end;
    return (
      <button type="button" onClick={() => go(dir)} aria-label={dir < 0 ? 'Anterior' : 'Siguiente'}
        data-testid={testid ? `${testid}-${dir < 0 ? 'prev' : 'next'}` : undefined}
        className={`hidden md:grid absolute top-1/2 -translate-y-1/2 ${dir < 0 ? '-left-5' : '-right-5'} z-10 w-11 h-11 place-items-center rounded-full bg-white text-[#1B2A4A] shadow-lg border border-slate-200 hover:bg-[#F8D13F] transition-[opacity,background-color] ${hidden ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
        {dir < 0 ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </button>
    );
  };

  return (
    <div className="relative">
      <Arrow dir={-1} />
      <div ref={ref} onScroll={update} data-testid={testid}
        className={`flex overflow-x-auto snap-x snap-mandatory scroll-smooth -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:scroll-px-0 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}>
        {children}
      </div>
      <Arrow dir={1} />
    </div>
  );
}
